import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { catalogApi, type CatalogDashboard } from '../../api/catalog';

export function CatalogDashboardPage() {
  const [dashboard, setDashboard] = useState<CatalogDashboard | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void catalogApi.dashboard().then(setDashboard).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/catalog" className="text-sm text-slate-600 hover:underline">← Catalogs</Link>
      <h1 className="mt-4 text-2xl font-semibold">Catalog Dashboard</h1>
      <p className="mt-1 text-sm text-slate-600">Health, completeness, and classification metrics.</p>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {Object.entries(dashboard?.stats ?? {}).map(([key, value]) => (
          <div key={key} className="rounded-xl border bg-white p-4">
            <p className="text-sm text-slate-500">{key.replace(/_/g, ' ')}</p>
            <p className="mt-1 text-2xl font-semibold">{String(value)}</p>
          </div>
        ))}
      </div>
      {!dashboard?.stats && !error && <p className="mt-6 text-slate-500">No dashboard stats yet.</p>}
    </div>
  );
}
